import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.color.warning2};
  background: ${({ theme }) => theme.color.warning3};

  > div {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-grow: 1;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    color: ${({ theme }) => theme.color.warning2};
    line-height: 140%;

    span {
      font-weight: 700;
    }

    svg {
      min-width: 20px;
      min-height: 20px;

      path {
        fill: ${({ theme }) => theme.color.warning2};
      }
    }
  }

  button {
    width: fit-content;
    padding: 6px 16px;
    height: 32px;
    font-size: 14px;
    white-space: nowrap;
  }
`;
